import { motion } from "framer-motion";
import { useLang } from "../lib/i18n";
import { SectionHead } from "./Reveal";

export const Process = () => {
  const { t } = useLang();
  return (
    <section id="process" className="relative py-24 sm:py-36" data-testid="process-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <SectionHead eyebrow={t.process.eyebrow} title={t.process.title} accent={t.process.accent} testid="process-title" />
        <div className="relative grid grid-cols-1 border-t border-emerald-500/20 sm:grid-cols-2 lg:grid-cols-4">
          <motion.div initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
            className="absolute -top-px left-0 h-[2px] w-full origin-left bg-[#00E676]" />
          {t.process.steps.map((s, i) => (
            <motion.div key={s.n} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.8, delay: 0.15 * i }} data-testid={`process-step-${i}`}
              className="group relative border-b border-emerald-500/10 py-10 pr-6 sm:border-r lg:border-b-0 lg:px-8 lg:first:pl-0">
              <span className="font-display text-7xl font-black text-outline-green transition-colors duration-500 group-hover:text-[#00E676] sm:text-8xl">{s.n}</span>
              <h3 className="mt-6 font-display text-2xl font-extrabold uppercase text-white">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-300 sm:text-base">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
